import JSZip from 'jszip';

export const extractJsonFromZip = async (byteArray) => {
    const jsonData = {
        blockedProfiles: null,
        closeFriends: null,
        followers1: null,
        following: null,
        recentFollowRequests: null,
        recentlyUnfollowedProfiles: null,
        removedSuggestions: null,
        restrictedProfiles: null
    };

    try {
        const zip = await JSZip.loadAsync(byteArray);

        for (const fileName of Object.keys(zip.files)) {
        console.log(`Processing file: ${fileName}`); // Log each file name

        // Extract file name from path
        const fileParts = fileName.split('/');
        const actualFileName = fileParts[fileParts.length - 1];

        const file = zip.file(fileName);
        if (file && actualFileName.endsWith('.json')) {
            const fileContent = await file.async('text');
            const cleanedContent = fileContent.trim();
            // const parsedData = JSON.parse(fileContent);
            // Only attempt parsing if it actually looks like JSON
            var parsedData;
            if (cleanedContent.startsWith('{') || cleanedContent.startsWith('[')) {
                parsedData = JSON.parse(cleanedContent);
            } else {
                console.log(`Skipping non-JSON file: ${fileName}`);
                continue;
            }

            switch (actualFileName) {
                case 'blocked_profiles.json':
                    jsonData.blockedProfiles = parsedData;
                    break;
                case 'close_friends.json':
                    jsonData.closeFriends = parsedData;
                    break;
                case 'followers_1.json':
                    jsonData.followers1 = parsedData;
                    break;
                case 'following.json':
                    jsonData.following = parsedData;
                    break;
                case 'recent_follow_requests.json':
                    jsonData.recentFollowRequests = parsedData;
                    break;
                case 'recently_unfollowed_profiles.json':
                    jsonData.recentlyUnfollowedAccounts = parsedData;
                    break;
                case 'removed_suggestions.json':
                    jsonData.removedSuggestions = parsedData;
                    break;
                case 'restricted_profiles.json':
                    jsonData.restrictedProfiles = parsedData;
                    break;
                default:
                    console.log(`File ${actualFileName} not handled.`);
                    break;
            }

            console.log(`Extracted data for ${actualFileName}:`, parsedData); // Log extracted JSON data
        }
        }
    } catch (error) {
        console.error('Error extracting ZIP file:', error); // Log any errors
    }

    return jsonData;
};

export const findNonFollowers = (followers, followings) => {
    if (!followers || !followings) return [];
  
    // 1️. Build a set of usernames of your followers
    const followerUsernames = new Set(
      followers.flatMap(f =>
        f.string_list_data?.map(d => d.value) || []
      )
    );
  
    // 2️. Filter followings who are NOT in follower set
    return followings.relationships_following
      .filter(f => {
        // Get username from title (following.json)
        const username = f.title || f.string_list_data?.[0]?.value;
        if (!username) return false;
  
        return !followerUsernames.has(username);
      })
      .map(f => {
        const username = f.title || f.string_list_data?.[0]?.value;
        const href = f.string_list_data?.[0]?.href || `https://www.instagram.com/${username}/`;
  
        return {
          username,
          href
        };
      });
};

// Download CSV helper
export const downloadNonFollowersCSV = (nonFollowers) => {
    const csv = "Username,Profile URL\n" + nonFollowers.map((u) => `${u.username},${u.href}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "non_followers.csv";
    a.click();
    URL.revokeObjectURL(url);
};